import React, { Fragment } from 'react';
import { guid } from '@bydesign-ui/utils';
import { usePrefixCls } from '@byte-design/config';
export function HighlightKeyword(props) {
  var _props$caseSensitive = props.caseSensitive,
      caseSensitive = _props$caseSensitive === void 0 ? true : _props$caseSensitive,
      label = props.label,
      keyword = props.keyword;
  var highlightCls = usePrefixCls('high-light');

  if (caseSensitive) {
    var _splits = keyword ? label.split(keyword) : [];

    if (_splits.length < 2) {
      return React.createElement(React.Fragment, {
        key: label || guid()
      }, label);
    }

    return React.createElement(Fragment, null, _splits.map(function (split, i) {
      return React.createElement(Fragment, {
        key: "".concat(i, "_").concat(split)
      }, split, i !== _splits.length - 1 && React.createElement("span", {
        key: split,
        className: highlightCls
      }, keyword));
    }));
  }

  var splits = keyword ? label.toLowerCase().split(keyword.toLowerCase()) : [];

  if (!keyword || splits.length < 2) {
    return React.createElement(React.Fragment, {
      key: label || guid()
    }, label);
  }

  var splitRanges = splits.reduce(function (ranges, item, index) {
    if (!index) {
      return [[0, item.length, item.length + keyword.length]];
    }

    var prevEnd = ranges[index - 1][2];
    ranges.push([prevEnd, prevEnd + item.length, prevEnd + item.length + keyword.length]);
    return ranges;
  }, []);
  return React.createElement(Fragment, null, splitRanges.map(function (range) {
    return React.createElement(Fragment, {
      key: range[0]
    }, label.slice(range[0], range[1]), React.createElement("span", {
      className: highlightCls
    }, label.slice(range[1], range[2])));
  }));
}